<template>
    <section class="Bank-transfer-wrapper withdraw-wrappwer">
        <div class="container">
            <div class="bank-withdaw-sec">
                <div class="withdraw-sec deposit_module">
                    <div class="back-modal">
                        <div class="withdawForm-group">
                            <div class="withdrawalForm-group">
                                <label><span>{{ $t('deposit-amount','Deposit Amount') }}</span></label>
                                <!-- <label>Available Balance: <span>{{ (($auth.user?.balance || 0) - (+lockedEarnedData?.earnBonus || 0) + parseInt($auth.user?.expl || 0)).toFixed(2) }}</span></label> -->
                            </div>
                            <input v-model="depositAmount" class="form-control profit-input" type="number" :placeholder="$t('enter-amount','Enter amount')" 
                            @input="depositAmount = $helper.sanitizeNumber(+depositAmount, +walletConfig?.deposit_range?.max || 99999999)"/>
                            <span class="error-messages-text" v-if="v$.depositAmount.$error">{{ $t('please-enter-amount','Please Enter Amount') }}</span>
                            <div class="online-form-int">
                                <label class="form-check-label gray-color">({{ $t('min-amount','Min amount') }}:  {{ walletConfig?.deposit_range ? walletConfig?.deposit_range.min: 100 }})</label>
                            </div>
                        </div>
                        <div class="thm-gradient-but deposit-amount-bx stake-button" v-if="walletConfig?.stake_button">
                            <ul>
                                <li v-for="(stake, index) in (userTransactionStakes ? [...userTransactionStakes] : walletConfig?.stake_button)" :key="index">
                                    <a @click="setStakeValue(stake)">
                                        <span class="btn-thm heigh-btn">
                                            +{{ stake }}
                                        </span>
                                    </a>
                               </li>
                            </ul>
                        </div>
                        <div class="withdraw-fix-sec continue-btn">
                            <a href="#walleteditstackModal" data-bs-toggle="modal" class="editStake-btn">
                                <span><img loading="lazy" src="@/assets/images/edit-icon.svg" alt="edit-icon"></span>
                                <span>{{$t('edit-stake', 'Edit Stake')}}</span>
                            </a>
                            <a href="javascript:void(0);" class="thm-but" id="account-successfully" data-bs-toggle="modal" data-bs-target="#instructionsModal">{{ $t('proceed','Proceed') }} </a>
                        </div>
                        <div class="mt-1">
                            <p class="text-center">-{{$t('or','or')}}-</p>
                            <div class="withdraw-btn deposit-btn">
                                <router-link  :to="{name: 'WalletWithdraw'}" class="thm-but" id="account-successfully">{{ $t('want-to-withdraw','Want to Withdraw') }} ?</router-link>
                            </div>
                        </div>
                        <TutorialVideo type = "2"/>
                    </div>
                </div>
            </div>
            <WalletInstructionVideos/>
        </div>
    </section>
    <WalletInstructionsModal instructionType="deposit" :actionMethod="callForDepositMethods"/>
    <WalletStakeModal ref="resetStakeCall" @updateStakes="getStakes" v-if="walletConfig" :stakes="walletConfig?.stake_button" />
    
</template>

<script>
import { defineAsyncComponent } from 'vue';
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { mapGetters } from 'vuex';
import { setWalletStakeValue } from '@template/utils';
import WalletInstructionsModal from '../components/WalletInstructionsModal.vue';
import WalletInstructionVideos from '../components/WalletInstructionVideos.vue';
import WalletStakeModal from '../components/WalletStakeModal.vue';
import TutorialVideo from '../components/TutorialVideo.vue';
export default {
    name: "WalletDeposit",
    setup() {
        return { v$: useVuelidate() }
    },
    inject: ['walletConfig','walletData','getStakes'],
    components: {
        WalletInstructionsModal,
        WalletInstructionVideos,
        WalletStakeModal,
          TutorialVideo
    },
    data(){
        return{
            depositAmount: null,
        }
    },
    validations: {
        depositAmount: { required}
    },
    computed: {
        ...mapGetters([
            'globalLoader', 'userTransactionStakes'
        ])
    },
    methods:{
        setStakeValue(stake) {
            try {
                const response =  setWalletStakeValue(stake, this.depositAmount, this.walletConfig)
                if(response){
                    this.depositAmount =  response; 
                }
            } catch (error) {
                this.$errorToast(error)
            }
        },
        callForDepositMethods(){
            this.v$.$touch()
            if (this.v$.$error) {
                console.log(this.v$.$error)
                return
            }else{
                if (this.depositAmount == null || this.depositAmount < this.walletConfig?.deposit_range?.min || this.depositAmount > this.walletConfig?.deposit_range?.max) {
                    this.$errorToast(`The deposit amount must be between ${this.walletConfig?.deposit_range?.min} and ${this.walletConfig?.deposit_range?.max}.`);
                } else {
                    this.$store.dispatch('setDepositAmount', this.depositAmount);
                    this.$router.push({ name: 'DepositPaymentMethod' })
                }
            }
        },
    }
}
</script>
<style scoped>
.withdraw-btn{
    margin-top: 0px;
}
</style>